var $ = require('jquery');

function searchAugment (mainSearch, faqSearch, protocolSearch, guestSearch) {
 $(function() {

  $('.tabbed-overlay__secondary-panel .search__filters').on('filtersUpdated', function() {


    if (mainSearch != undefined) {
      showHideFilterBtns(this, mainSearch.init);

      if (mainSearch.init) {
        var $filterGrp = $(this);
        $filterGrp.find(':checked').each(function() {
          $(this).parent('.search__filter').insertBefore($filterGrp.find('.search__filter:eq(0)'));
        })
        $filterGrp.find('[value="Nanopore Store"]').each(function() {
          $(this).parent('.search__filter').insertBefore($filterGrp.find('.search__filter:eq(0)'));
        })
      }
    }

    if (protocolSearch != undefined) {
      protocolSearch.panelResultsUpdate = function(data) {
        const deviceFilter = data.panel.searchForm.filterObj.device
        if (deviceFilter != undefined) {
          const device = deviceFilter['AND'].or[0]
          if (device != undefined) {
            $.each(data.results.hits,function(index, hit) {
              hit.url = hit.url + '?devices=' + device.toLowerCase()
            })
          }
        }
      }
    }

   });

   $('#mainSearch .search__result-panel').on('searchPageChanged', function() {
     console.log('pageChanged');
   });

   $('#mainSearch').on('beforeInit', function() {
     beforeInit();
   });

   function beforeInit() {
     var $filterGrps = $('.tabbed-overlay__secondary-panel .search__filters'),
       $filterGrp, $filters, $lastFilter, $trimFilter;

     $filterGrps.filter('[data-filter-display]').each(function() {
       $filterGrp = $(this);
       $filterGrp.append('<button class="search__filters-showbtn more">Show more</button>');
       $filterGrp.find('.search__filters-showbtn').click(function(e) {
         e.preventDefault();
         var $btn = $(e.currentTarget);
         if (!$btn.hasClass('more')) {
           showFilters($btn);
         } else {
           hideFilters($btn);
         }
       });
     });
   }

   function showFilters($btn, heightOnly) {
     var $filterGrp = $btn.closest('.search__filters'),
       $filters = $filterGrp.find('.search__filter:not(.search__filter-tpl)'),
       $lastFilter = $filters.last();

     $filterGrp
       .removeClass('search__filters--trimmed')
       .height($lastFilter.position().top + $lastFilter.outerHeight(true) + 30);

     if (!heightOnly) {
       $btn.text('Show less').addClass('more');
     }
   }

   function hideFilters($btn, heightOnly) {
      var $filterGrp = $btn.closest('.search__filters'),
       $filters = $filterGrp.find('.search__filter:not(.search__filter-tpl)'),
       $trimFilter = $filters.eq($filterGrp.data('filter-display')-1);

     $filterGrp.height($trimFilter.position().top + $trimFilter
       .outerHeight(true) + 10)
       .addClass('search__filters--trimmed');

     if (!heightOnly) {
       $btn.text('Show more').removeClass('more');
     }
   }

   function showHideFilterBtns(filterGrp, onLoad) {
     var $filterGrp = $(filterGrp),
       $filters, $lastFilter, $trimFilter, $btn;
     onLoad = onLoad || false;

     $filters = $filterGrp.find('.search__filter:not(.search__filter-tpl)');
     $btn = $filterGrp.find('.search__filters-showbtn');

     if (!$btn.length) {
       beforeInit();
       $btn = $filterGrp.find('.search__filters-showbtn');
     }

     if ($filters.length > $filterGrp.data('filter-display')) {
       $btn = $filterGrp.find('.search__filters-showbtn');
       $btn.show();

       if (onLoad) {
         hideFilters($btn);
       } else {
         if ($btn.hasClass('more')) {
           showFilters($btn, true);
         } else {
           hideFilters($btn, true);
         }
       }
     } else {
       $filterGrp
         .removeClass('search__filters--trimmed')
         .height('auto');
       $btn.hide();

       if (onLoad) {
         $btn.removeClass('more');
       }
     }
   }
 });

  var $faqSearch = $('#faqSearch');
  $faqSearch.find('.search__result-panel').on('beforeSearch', function() {
    faqSearch.searchPanels[0].panel.queryParams.filters = 'type:faq';
    if (faqSearch.searchVal.length > 1) {
      faqSearch.searchPanels[0].panel.queryParams['distinct'] = 4;
    } else {
      faqSearch.searchPanels[0].panel.queryParams['distinct'] = false;
    }
  });

  var $protocolSearch = $('#protocolSearch');

  $protocolSearch.find('.search__result-panel').on('beforeSearch', function() {
    if (protocolSearch.searchPanels[0].panel.queryParams.filters.length > 0 )
    {
      protocolSearch.searchPanels[0].panel.queryParams.filters = '(type:"protocol") AND ' + protocolSearch.searchPanels[0].panel.queryParams.filters;
    }
    else
    {
      protocolSearch.searchPanels[0].panel.queryParams.filters = 'type:"protocol"';
    }
    $('#search-result-count').css('display', 'none');
  })
  $protocolSearch.on('resultsFound', function() {
    if (protocolSearch.searchVal == '*') {
      $('.search__results h3').hide();
    } else {
      $('.search__results h3').show();
      if (protocolSearch.currentResults[protocolSearch.searchPanels[0].index]) {
        const hitCountTitle = protocolSearch.currentResults[protocolSearch.searchPanels[0].index].nbHits;
        $('#search-result-count-title').text(hitCountTitle + ' ' +  (hitCountTitle == 1 ? 'protocol' : 'protocols'));
        if (hitCountTitle == 0) {
          $('#search-result-count').css('display', 'inline-block');
        }
      }
    }
  });

  var $guestSearch = $('#guestSearch');

  $guestSearch.find('.search__result-panel').on('beforeSearch', function() {
    if (guestSearch.searchPanels[0].panel.queryParams.filters.length > 0 )
    {
      guestSearch.searchPanels[0].panel.queryParams.filters = '((type:"protocol") OR (type:"technical_document") OR (type:"info_sheet")) AND ' + guestSearch.searchPanels[0].panel.queryParams.filters;
    }
    else
    {
      guestSearch.searchPanels[0].panel.queryParams.filters = '(type:"protocol") OR (type:"technical_document") OR (type:"info_sheet")';
    }
    $('#search-result-count').css('display', 'none');
  })
}
module.exports = searchAugment;

window.deviceList = function(list) {
  return list.join(', ');
}
